import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-88766e4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "el-upload-list__item-actions" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]

import { t } from '@/plugins/i18n'
import { reactive, ref, watch, toRaw } from 'vue'
import { Delete, Plus } from '@element-plus/icons-vue'
import { getSignNewApi } from '@/apis/oss'
import useFileUtils from '@/util/useFileUtils'
import { uid } from 'uid/dist/index.js'
import { getRandomFileName, getBucketName } from '@/util/useUpload'
import { ElMessage, UploadUserFile, UploadProps } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  props: {
  limit: {
    type: Number,
    default: 5
  },
  limitFile: {
    type: Object,
    default: () => ({
      accept: '.jpg,.jpeg,.png,.JPG,.JPEG,.PNG',
      beforeUpload: (file: any) => {
        const { getExtension } = useFileUtils()
        const ext = getExtension(file.name)
        const limitList = ['jpg', 'jpeg', 'png', 'JPG', 'JPEG', 'PNG']
        console.log(ext)
        if (!limitList.includes(ext)) {
          ElMessage.warning(t('上传文件只能是X格式').replace('X', [...new Set(limitList.map(v => v.toUpperCase()))].join('/')))
          return false
        }
        const size = file.size / 1024 / 1024
        if (size > 50) {
          ElMessage.warning('文件大小不超过50m')
          return false
        }
        return true
      }
    })
  },
  urlList: {
    type: Array,
    default: () => []
  },
  // 读取权限 true  允许读取
  readAuto: {
    type: Boolean,
    default: true
  },
  // 是否允许覆盖
  overwrite: {
    type: Boolean,
    default: false
  },
  // 业务类型
  bizType: {
    type: String,
    default: 'client'
  },
  path: {
    type: String,
    default: 'client/'
  },
  fileName: {
    type: String,
    default: ''
  }
},
  emits: ['change', 'update:urlList'],
  setup(__props, { emit }) {

const props = __props


const { getExtension } = useFileUtils()
const host = ref('')
const uploadParams:any = reactive({
  name: '',
  key: '',
  policy: '',
  OSSAccessKeyId: '',
  success_action_status: 200,
  signature: ''
})

const urlList = (props.urlList || []).map((e:any) => ({ name: e, url: e }))
const fileList = ref<UploadUserFile[]>(urlList)
const delFile = () => {
  fileList.value = []
  handleChange()
}

watch(() => props.urlList, (newValue) => {
  const urlList = (newValue || []).map((e:any) => ({ name: e, url: e }))
  fileList.value = urlList
})

const beforeUpload = (file: any) => {
  if (props.limitFile?.beforeUpload(file)) {
    return getOssSign(file)
  }
  return false
}

const handleChange = () => {
  const list = toRaw(fileList.value)
  emit('update:urlList', list.map((e: any) => {
    if (e?.raw?.url) {
      return e.raw.url
    } else {
      return e.url
    }
  }))
  emit('change', fileList.value[0])
}

/**
 * 获取阿里云上传签名等参数
 */
const loading = ref(false)
const getOssSign = (file: any) => {
  return new Promise((resolve: any, reject: any): any => {
    loading.value = true
    getSignNewApi({
      bucketName: getBucketName(),
      path: props.path,
      type: props.overwrite ? 1 : 0
    })
      .then((res: any) => {
        const data = res.data
        // uploadParams.name = file.name
        // uploadParams.key = `${data.dir}${uid()}`
        // const ext = getExtension(file.name)
        // if (ext && ext.length > 0) {
        //   uploadParams.key = `${uploadParams.key}.${ext}`
        // }
        // uploadParams.policy = data.policy
        // uploadParams.OSSAccessKeyId = data.accessId
        // uploadParams.signature = data.signature
        const key = getRandomFileName({
          file,
          path: props.path,
          overwrite: props.overwrite,
          fileName: props.fileName,
          readAuto: props.readAuto,
          bizType: props.bizType
        })
        uploadParams.name = file.name
        uploadParams['Content-Disposition'] = 'inline'
        uploadParams.key = key
        uploadParams.policy = data.policy
        uploadParams.OSSAccessKeyId = data.accessId
        uploadParams.signature = data.signature
        uploadParams['x-oss-object-acl'] = props.readAuto ? 'public-read' : 'private'
        uploadParams['x-oss-forbid-overwrite'] = !!props.overwrite

        host.value = data.host.replace(/http[s]?:/, location.protocol)
        // this.customDomain = data.customDomain
        // // 上传后文件的访问url
        // file.url = `${this.customDomain}/${this.uploadParams.key}`
        console.log(`${data.customDomain}/${uploadParams.key}`)
        file.url = `${data.customDomain}/${uploadParams.key}`
        resolve(true)
      })
      .catch((error) => {
        console.error('error', error)
        reject(new Error())
      })
      .finally(() => {
        // do nothing
        loading.value = false
      })
  })
}

const dialogImageUrl = ref('')
const dialogVisible = ref(false)

const handleRemove: UploadProps['onRemove'] = (uploadFile) => {
  let list = toRaw(fileList.value)
  list = list.map((e: any) => {
    if (e?.raw?.url) {
      return e.raw.url
    } else {
      return e.url
    }
  })
  emit('update:urlList', list.filter((e: any) => e !== uploadFile.url))
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_el_upload, {
      ref: (_value, _refs) => {
        _refs['uploadRef'] = _value
      },
      class: "uploader",
      "list-type": "picture-card",
      accept: __props.limitFile?.accept,
      "before-upload": (beforeUpload as any),
      action: host.value,
      data: _unref(uploadParams),
      "file-list": fileList.value,
      limit: __props.limit,
      onSuccess: handleChange
    }, {
      file: _withCtx(({ file }) => [
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            referrerPolicy: "no-referrer",
            class: "el-upload-list__item-thumbnail",
            src: file.url,
            alt: ""
          }, null, 8, _hoisted_1),
          _createElementVNode("span", _hoisted_2, [
            _createElementVNode("span", {
              class: "el-upload-list__item-delete",
              onClick: ($event: any) => (handleRemove(file))
            }, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_unref(Delete))
                ]),
                _: 1
              })
            ], 8, _hoisted_3)
          ])
        ])
      ]),
      tip: _withCtx(() => [
        _renderSlot(_ctx.$slots, "tip")
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_unref(Plus))
          ]),
          _: 1
        })
      ]),
      _: 3
    }, 8, ["accept", "before-upload", "action", "data", "file-list", "limit"]), [
      [_directive_loading, loading.value]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          referrerPolicy: "no-referrer",
          "w-full": "",
          src: dialogImageUrl.value,
          alt: "Preview Image"
        }, null, 8, _hoisted_4)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})